module.exports = __webpack_public_path__ + "static/cloud-illustration-2-85dd832081db24a4d0deced9e72e8960.svg";